<template>
  <div class="node-wrapper" v-loading.fullscreen.lock="uploading" v-if="game">
    <el-form label-width="100px">
      <el-form-item label="标题">
        <el-input v-model="game.title" />
      </el-form-item>
      <el-form-item label="故事概要" style="margin-bottom: 20px;">
        <el-input type="textarea" v-model="game.description" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入故事概要..." />
      </el-form-item>

      <!-- 选择推理模型 -->
      <el-form-item label="推理模型" style="margin-bottom: 20px;">
        <el-select v-model="game.model_id" placeholder="请选择模型" filterable clearable>
          <el-option
            v-for="m in models"
            :key="m.id"
            :label="`${m.model}(${m.channel})`"
            :value="m.id"
          />
        </el-select>
<!--        <div v-if="selectedModelDesc" style="color:#888; margin-top:6px; line-height:1.5;">-->
<!--          {{ selectedModelDesc }}-->
<!--        </div>-->
      </el-form-item>

      <!-- 上传封面 -->
      <el-form-item label="上传封面">
        <el-upload
          class="upload-cover"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :data="{ game_id: game.id }"
          :on-success="handleCoverUploadSuccess"
          :show-file-list="false"
          :before-upload="() => { uploading = true; return true; }"
        >
          <el-button type="primary">上传封面</el-button>
        </el-upload>
        <div v-if="game.url" style="margin-top: 10px;">
          <img :src="game.url" style="max-height: 200px; width: auto; border: 1px solid #ccc;" />
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveGame">保存概要</el-button>
      </el-form-item>
    </el-form>
    <h2>节点列表</h2>

    <draggable v-model="nodes" @end="onDragEnd" handle=".handle">
      <div
        v-for="node in nodes"
        :key="node.id"
        class="node-block"
      >
        <div style="display: flex; align-items: center; margin-bottom: 20px;">
          <div class="handle" style="cursor: grab;">⬍ 拖动</div>
          <span style="font-weight: bold; margin-left: 12px;">{{ node.title }}</span>
          <el-button size="mini" style="margin-left: 12px;" @click="toggleNodeExpanded(node)">
            {{ node.expanded ? '收起' : '展开' }}
          </el-button>
          <el-button size="mini" type="primary" style="margin-left: 8px;" @click="copyNode(node)">
            复制
          </el-button>
        </div>
        <div v-if="node.expanded">
          <el-form label-width="100px" :model="node">
            <!-- 第一行：节点类型, ID, 大章节 -->
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="节点类型">
                  <el-select v-model="node.node_type" placeholder="请选择类型">
                    <el-option
                      v-for="opt in nodeTypeOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="ID">
                  <el-input v-model="node.id" :disabled="true" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="大章节" prop="user_chapter_id">
                  <el-select v-model="node.game_chapter_id" placeholder="请选择大章节" filterable clearable>
                    <el-option
                      v-for="c in chapters"
                      :key="c.id"
                      :label="c.title"
                      :value="c.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第二行：标题, 回合数限制 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="标题">
                  <el-input v-model="node.title" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回合数限制">
                  <el-input-number v-model="node.limit_turn" :min="0" placeholder="输入回合数限制" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="描述">
              <el-input type="textarea" v-model="node.description" :autosize="{ minRows: 2, maxRows: 15 }"/>
            </el-form-item>
            <!-- 新增背景图上传 -->
            <el-form-item label="背景图">
              <el-upload
                class="upload-bg"
                :action="uploadUrl"
                :headers="uploadHeaders"
                :data="{ game_id: game.id }"
                :on-success="(res) => handleUploadSuccess(res, node, 'bg_url')"
                :show-file-list="false"
                :before-upload="() => { uploading = true; return true; }"
              >
                <el-button type="primary">上传背景图</el-button>
              </el-upload>
              <div style="margin-bottom:6px;color:#666;">
                  文件名：<span style="font-weight:600;">{{ getFileName(node.bg_url) }}</span>
              </div>
              <div v-if="node.bg_url" style="margin-top: 10px;">
                <img :src="node.bg_url" style="max-height: 200px; width: auto; border: 1px solid #ccc;" />
              </div>
            </el-form-item>
            <!-- 新增背景音乐上传 -->
            <el-form-item label="背景音乐">
              <el-upload
                class="upload-music"
                :action="uploadUrl"
                :headers="uploadHeaders"
                :data="{ game_id: game.id }"
                :on-success="(res) => handleUploadSuccess(res, node, 'music_url')"
                :show-file-list="false"
                :before-upload="() => { uploading = true; return true; }"
              >
                <el-button type="primary">上传背景音乐</el-button>
              </el-upload>
              <div v-if="node.music_url" style="margin-top: 10px;">
                <div style="margin-bottom:6px;color:#666;">
                  文件名：<span style="font-weight:600;">{{ getFileName(node.music_url) }}</span>
                </div>
                <audio
                  ref="audioPlayerRef"
                  :data-id="node.id"
                  :src="node.music_url"
                  style="width: 100%;"
                />
                <el-button size="mini" style="margin-top: 5px;" @click="playAudio(node.id)">▶ 播放</el-button>
              </div>
            </el-form-item>
            <el-form-item label="场景中的角色">
              <el-select v-model="node.role_ids" multiple placeholder="选择角色">
                <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
              </el-select>
            </el-form-item>
            <!-- 开场白：两个独立的表单项并排显示 -->
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="开场白角色">
                  <el-select v-model="node.prologue_role_id" placeholder="选择角色">
                    <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="开场白内容">
                  <el-input type="textarea" v-model="node.prologue" placeholder="输入开场白内容" />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- Fixed节点：对话列表 -->
            <div v-if="node.node_type === 'fixed'">
              <el-divider>对话列表</el-divider>
              <el-form-item label="剧情对话">
                <draggable v-model="node.dialogues" :handle="'.drag-dialogue-handle'" animation="200">
                  <div
                    v-for="(d, didx) in node.dialogues"
                    :key="didx"
                    style="display: flex; align-items: center; margin-bottom: 6px;"
                  >
                    <span class="drag-dialogue-handle" style="cursor: move; font-size: 20px; margin-right: 6px;">⠿</span>
                    <!-- 角色选择下拉 -->
                    <el-select v-model="d.role_id" placeholder="选择角色" style="width: 120px;">
                      <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
                    </el-select>
                    <!-- 角色台词输入 -->
                    <el-input type="textarea" v-model="d.text" placeholder="角色说的话" style="margin-left: 10px; flex: 1;" />
                    <el-button type="danger" size="mini" icon="el-icon-delete" style="margin-left: 6px;" @click="removeDialogue(node, didx)" />
                  </div>
                </draggable>
                <!-- 添加对话 -->
                <el-button type="primary" plain size="mini" @click="addDialogue(node)" style="margin-top: 6px;">
                  新增对话
                </el-button>
              </el-form-item>
            </div>

            <!-- AI节点专有字段 -->
            <div v-if="node.node_type === 'ai'">
              <el-divider>AI节点设置</el-divider>

              <!-- 故事背景 -->
              <el-form-item label="故事背景">
                <el-input type="textarea" v-model="node.story_background" :autosize="{ minRows: 3, maxRows: 6 }" placeholder="请输入故事背景..." />
              </el-form-item>

              <!-- 当前剧情 -->
              <el-form-item label="当前剧情">
                <el-input type="textarea" v-model="node.current_plot" :autosize="{ minRows: 3, maxRows: 6 }" placeholder="请输入当前剧情..." />
              </el-form-item>

              <!-- 攻略方式 -->
              <el-form-item label="攻略方式">
                <el-input type="textarea" v-model="node.node_task" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入攻略方式..." />
              </el-form-item>

              <!-- 角色设置 -->
              <el-form-item label="角色设置">
                <div v-for="(roleConfig, index) in node.user_special" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
                  <div style="display: flex; align-items: center; margin-bottom: 10px;">
                    <span style="font-weight: bold; margin-right: 10px;">角色配置 {{index + 1}}</span>
                    <el-button type="danger" size="mini" @click="removeRoleConfig(node, index)">删除</el-button>
                  </div>
                  <el-form-item label="角色名称">
                    <el-select v-model="roleConfig.role_id" placeholder="选择角色">
                      <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="角色任务">
                    <el-input type="textarea" v-model="roleConfig.task" placeholder="请输入角色任务" />
                  </el-form-item>
                  <el-form-item label="说话时机">
                    <el-input type="textarea" v-model="roleConfig.speak_timing" placeholder="请输入说话时机" />
                  </el-form-item>
                  <el-form-item label="说话语气">
                    <el-input type="textarea" v-model="roleConfig.speak_tone" placeholder="请输入说话语气" />
                  </el-form-item>
                  <el-form-item label="人设">
                    <el-input type="textarea" v-model="roleConfig.character_setting" placeholder="请输入人设" />
                  </el-form-item>
                </div>
                <el-button type="primary" plain size="mini" @click="addRoleConfig(node)" style="margin-top: 10px;">
                  添加角色配置
                </el-button>
              </el-form-item>

              <!-- 进度指标 -->
              <el-form-item label="进度指标">
                <div v-for="(processItem, index) in node.process" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
                  <div style="display: flex; align-items: center; margin-bottom: 10px;">
                    <span style="font-weight: bold; margin-right: 10px;">指标 {{index + 1}}</span>
                    <el-button type="danger" size="mini" @click="removeProcess(node, index)">删除</el-button>
                  </div>
                  <el-form-item label="进度名称">
                    <el-input v-model="processItem.name" placeholder="请输入进度名称，如'愤怒值'" />
                  </el-form-item>
                  <el-form-item label="进度提升规则">
                    <el-input type="textarea" v-model="processItem.progress_change_rules" placeholder="请输入进度指标如何提升的规则" :autosize="{ minRows: 8, maxRows: 50 }" />
                  </el-form-item>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="开始进度值">
                        <el-input-number v-model="processItem.start_process" :min="0" placeholder="开始值" style="width: 100%" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="结束进度值">
                        <el-input-number v-model="processItem.end_process" :min="0" placeholder="结束值" style="width: 100%" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="奖励配置">
                    <div v-for="(award, awardIndex) in processItem.award_conf" :key="awardIndex" style="border: 1px solid #eee; padding: 10px; margin-bottom: 8px; border-radius: 4px;">
                      <div style="display: flex; align-items: center; margin-bottom: 8px;">
                        <span style="font-weight: normal; margin-right: 10px;">奖励 {{awardIndex + 1}}</span>
                        <el-button type="danger" size="mini" @click="removeProcessAward(processItem, awardIndex)">删除</el-button>
                      </div>
                      <el-form-item label="奖励类型">
                        <el-select v-model="award.type" placeholder="请选择奖励类型">
                          <el-option label="成就" value="成就" />
                          <el-option label="道具" value="道具" />
                          <el-option label="好感度" value="好感度" />
                          <el-option label="事件" value="事件" />
                          <el-option label="属性" value="属性" />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="角色" v-if="award.type === '好感度'">
                        <el-select v-model="award.reward_character_id" placeholder="请选择角色">
                          <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="属性名称" v-if="award.type === '属性'">
                        <el-select v-model="award.attribute_name" placeholder="请选择属性">
                          <el-option label="武力值" value="武力值" />
                          <el-option label="智慧值" value="智慧值" />
                          <el-option label="体力值" value="体力值" />
                          <el-option label="灵敏值" value="灵敏值" />
                          <el-option label="精神值" value="精神值" />
                          <el-option label="圣母值" value="圣母值" />
                          <el-option label="黑化值" value="黑化值" />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="奖励描述" v-if="award.type !== '好感度' && award.type !== '属性'">
                        <el-input
                          v-model="award.reward_description"
                          placeholder="请输入奖励描述"
                        />
                      </el-form-item>
                      <el-form-item label="好感度数值" v-if="award.type === '好感度'">
                        <el-input-number
                          :value="parseFloat(award.reward_description) || 0"
                          @input="award.reward_description = String($event)"
                          placeholder="请输入好感度数值"
                          :precision="0"
                          controls-position="right"
                          style="width: 100%"
                        />
                      </el-form-item>
                      <el-form-item label="属性数值" v-if="award.type === '属性'">
                        <el-input-number
                          v-model="award.attribute_value"
                          placeholder="请输入属性数值"
                          :precision="0"
                          controls-position="right"
                          style="width: 100%"
                        />
                      </el-form-item>
                    </div>
                    <el-button type="primary" plain size="mini" @click="addProcessAward(processItem)" style="margin-top: 6px;">
                      添加奖励
                    </el-button>
                  </el-form-item>
                  <el-form-item label="后续剧情">
                    <div v-if="Array.isArray(processItem.after_story) && processItem.after_story.length > 0">
                      <draggable v-model="processItem.after_story" :handle="'.drag-after-story-handle'" animation="200">
                        <div
                          v-for="(story, storyIdx) in processItem.after_story"
                          :key="storyIdx"
                          style="border: 1px solid #eee; padding: 10px; margin-bottom: 8px; border-radius: 4px;"
                        >
                          <div style="display: flex; align-items: center; margin-bottom: 8px;">
                            <span class="drag-after-story-handle" style="cursor: move; font-size: 20px; margin-right: 6px;">⠿</span>
                            <span style="font-weight: normal; margin-right: 10px;">剧情对话 {{storyIdx + 1}}</span>
                            <el-button type="danger" size="mini" @click="removeAfterStoryItem(processItem, storyIdx)">删除</el-button>
                          </div>
                          <el-form-item label="角色">
                            <el-select v-model="story.role_id" placeholder="选择角色" style="width: 100%;">
                              <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
                            </el-select>
                          </el-form-item>
                          <el-form-item label="对话内容">
                            <el-input type="textarea" v-model="story.text" :autosize="{ minRows: 3, maxRows: 10 }" placeholder="请输入对话内容..." />
                          </el-form-item>
                        </div>
                      </draggable>
                    </div>
                    <el-button type="primary" plain size="mini" @click="addAfterStoryItem(processItem)" style="margin-top: 6px;">
                      添加后续剧情对话
                    </el-button>
                  </el-form-item>
                </div>
                <el-button type="primary" plain size="mini" @click="addProcess(node)" style="margin-top: 10px;">
                  添加进度指标
                </el-button>
              </el-form-item>

              <!-- 彩蛋 -->
              <el-form-item label="彩蛋">
                <div v-for="(egg, index) in node.egg" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
                  <div style="display: flex; align-items: center; margin-bottom: 10px;">
                    <span style="font-weight: bold; margin-right: 10px;">彩蛋 {{index + 1}}</span>
                    <el-button type="danger" size="mini" @click="removeEgg(node, index)">删除</el-button>
                  </div>
                  <el-form-item label="彩蛋名称">
                    <el-input v-model="egg.name" placeholder="请输入彩蛋名称" />
                  </el-form-item>
                  <el-form-item label="触发条件">
                    <el-input type="textarea" v-model="egg.trigger_condition" placeholder="请输入触发条件" />
                  </el-form-item>
                  <el-form-item label="奖励类型">
                    <el-select v-model="egg.reward_type" placeholder="请选择奖励类型">
                      <el-option label="成就" value="成就" />
                      <el-option label="道具" value="道具" />
                      <el-option label="好感度" value="好感度" />
                      <el-option label="事件" value="事件" />
                      <el-option label="属性" value="属性" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="角色" v-if="egg.reward_type === '好感度'">
                    <el-select v-model="egg.reward_character_id" placeholder="请选择角色">
                      <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="属性名称" v-if="egg.reward_type === '属性'">
                    <el-select v-model="egg.attribute_name" placeholder="请选择属性">
                      <el-option label="武力值" value="武力值" />
                      <el-option label="智慧值" value="智慧值" />
                      <el-option label="体力值" value="体力值" />
                      <el-option label="灵敏值" value="灵敏值" />
                      <el-option label="精神值" value="精神值" />
                      <el-option label="圣母值" value="圣母值" />
                      <el-option label="黑化值" value="黑化值" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="具体奖励" v-if="egg.reward_type !== '好感度' && egg.reward_type !== '属性'">
                    <el-input
                      v-model="egg.reward_description"
                      placeholder="请输入具体奖励描述"
                    />
                  </el-form-item>
                  <el-form-item label="好感度数值" v-if="egg.reward_type === '好感度'">
                    <el-input-number
                      :value="parseFloat(egg.reward_description) || 0"
                      @input="egg.reward_description = String($event)"
                      placeholder="请输入好感度数值"
                      :precision="0"
                      controls-position="right"
                      style="width: 100%"
                    />
                  </el-form-item>
                  <el-form-item label="属性数值" v-if="egg.reward_type === '属性'">
                    <el-input-number
                      v-model="egg.attribute_value"
                      placeholder="请输入属性数值"
                      :precision="0"
                      controls-position="right"
                      style="width: 100%"
                    />
                  </el-form-item>
                </div>
                <el-button type="primary" plain size="mini" @click="addEgg(node)" style="margin-top: 10px;">
                  添加彩蛋
                </el-button>
              </el-form-item>
               <!-- 输出示例 -->
              <el-form-item label="输出示例">
                <div v-for="(example, index) in node.output_examples" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
                  <div style="display: flex; align-items: center; margin-bottom: 10px;">
                    <span style="font-weight: bold; margin-right: 10px;">示例 {{index + 1}}</span>
                    <el-button type="danger" size="mini" @click="removeOutputExample(node, index)">删除</el-button>
                  </div>
                  <el-form-item label="示例内容">
                    <el-input type="textarea" v-model="example.content" :autosize="{ minRows: 5, maxRows: 8 }" placeholder="请输入输出示例..." />
                  </el-form-item>
                </div>
                <el-button type="primary" plain size="mini" @click="addOutputExample(node)" style="margin-top: 10px;">
                  添加示例
                </el-button>
              </el-form-item>
              <!-- JSON输出示例 -->
              <el-form-item label="JSON输出示例">
                <div v-for="(example, index) in node.output_examples_json" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
                  <div style="display: flex; align-items: center; margin-bottom: 10px;">
                    <span style="font-weight: bold; margin-right: 10px;">JSON示例 {{index + 1}}</span>
                    <el-button type="danger" size="mini" @click="removeOutputExampleJson(node, index)">删除</el-button>
                  </div>
                  <el-form-item label="示例内容">
                    <el-input type="textarea" v-model="example.content" :autosize="{ minRows: 5, maxRows: 15 }" placeholder="请输入JSON输出示例..." />
                  </el-form-item>
                  <!-- 如果是复杂JSON对象，显示为只读的格式化JSON -->
                  <div v-if="!example.content && typeof example === 'object'" style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin-top: 10px;">
                    <pre style="margin: 0; white-space: pre-wrap; word-wrap: break-word;">{{ JSON.stringify(example, null, 2) }}</pre>
                  </div>
                </div>
                <el-button type="primary" plain size="mini" @click="addOutputExampleJson(node)" style="margin-top: 10px;">
                  添加JSON示例
                </el-button>
              </el-form-item>
            </div>

            <el-form-item>
              <el-button type="primary" @click="updateNodeData(node)">保存</el-button>
              <el-button type="danger" @click="deleteNodeData(node.id)">删除</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-divider />
      </div>
    </draggable>

    <h3>新增节点</h3>
    <el-form label-width="100px" :model="newNode">
      <!-- 第一行：节点类型, ID, 大章节 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="节点类型">
            <el-select v-model="newNode.node_type" placeholder="请选择类型" @change="onNewNodeTypeChange">
              <el-option v-for="opt in nodeTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="ID">
            <el-input value="新建中..." :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="大章节" prop="user_chapter_id">
            <el-select v-model="newNode.game_chapter_id" placeholder="请选择大章节" filterable clearable>
              <el-option
                v-for="c in chapters"
                :key="c.id"
                :label="c.title"
                :value="c.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 第二行：标题, 回合数限制 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="标题">
            <el-input v-model="newNode.title" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="回合数限制">
            <el-input-number v-model="newNode.limit_turn" :min="0" placeholder="输入回合数限制" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="描述">
        <el-input type="textarea" v-model="newNode.description" :autosize="{ minRows: 2, maxRows: 15 }"/>
      </el-form-item>

      <!-- Fixed节点：对话列表 -->
      <div v-if="newNode.node_type === 'fixed'">
        <el-divider>对话列表</el-divider>
        <el-form-item label="剧情对话">
          <draggable v-model="newNode.dialogues" :handle="'.drag-dialogue-handle'" animation="200">
            <div
              v-for="(d, didx) in newNode.dialogues"
              :key="didx"
              style="display: flex; align-items: center; margin-bottom: 6px;"
            >
              <span class="drag-dialogue-handle" style="cursor: move; font-size: 20px; margin-right: 6px;">⠿</span>
              <!-- 角色选择下拉 -->
              <el-select v-model="d.role_id" placeholder="选择角色" style="width: 120px;">
                <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
              </el-select>
              <!-- 角色台词输入 -->
              <el-input type="textarea" v-model="d.text" placeholder="角色说的话" style="margin-left: 10px; flex: 1;" />
              <el-button type="danger" size="mini" icon="el-icon-delete" style="margin-left: 6px;" @click="removeDialogue(newNode, didx)" />
            </div>
          </draggable>
          <!-- 添加对话 -->
          <el-button type="primary" plain size="mini" @click="addDialogue(newNode)" style="margin-top: 6px;">
            新增对话
          </el-button>
        </el-form-item>
      </div>

      <el-form-item label="场景中的角色">
        <el-select v-model="newNode.role_ids" multiple placeholder="选择角色">
          <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
        </el-select>
      </el-form-item>
      <!-- 开场白：两个独立的表单项并排显示 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="开场白角色">
            <el-select v-model="newNode.prologue_role_id" placeholder="选择角色">
              <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="开场白内容">
            <el-input type="textarea" v-model="newNode.prologue" placeholder="输入开场白内容" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- AI节点专有字段 -->
      <div v-if="newNode.node_type === 'ai'">
        <el-divider>AI节点设置</el-divider>

        <!-- 故事背景 -->
        <el-form-item label="故事背景">
          <el-input type="textarea" v-model="newNode.story_background" :autosize="{ minRows: 3, maxRows: 6 }" placeholder="请输入故事背景..." />
        </el-form-item>

        <!-- 当前剧情 -->
        <el-form-item label="当前剧情">
          <el-input type="textarea" v-model="newNode.current_plot" :autosize="{ minRows: 3, maxRows: 6 }" placeholder="请输入当前剧情..." />
        </el-form-item>

        <!-- 攻略方式 -->
        <el-form-item label="攻略方式">
          <el-input type="textarea" v-model="newNode.node_task" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入攻略方式..." />
        </el-form-item>
        <!-- 角色设置 -->
        <el-form-item label="角色设置">
          <div v-for="(roleConfig, index) in newNode.user_special" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <span style="font-weight: bold; margin-right: 10px;">角色配置 {{index + 1}}</span>
              <el-button type="danger" size="mini" @click="removeRoleConfig(newNode, index)">删除</el-button>
            </div>
            <el-form-item label="角色名称">
              <el-select v-model="roleConfig.role_id" placeholder="选择角色">
                <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="角色任务">
              <el-input type="textarea" v-model="roleConfig.task" placeholder="请输入角色任务" />
            </el-form-item>
            <el-form-item label="说话时机">
              <el-input type="textarea" v-model="roleConfig.speak_timing" placeholder="请输入说话时机" />
            </el-form-item>
            <el-form-item label="说话语气">
              <el-input type="textarea" v-model="roleConfig.speak_tone" placeholder="请输入说话语气" />
            </el-form-item>
            <el-form-item label="人设">
              <el-input type="textarea" v-model="roleConfig.character_setting" placeholder="请输入人设" />
            </el-form-item>
          </div>
          <el-button type="primary" plain size="mini" @click="addRoleConfig(newNode)" style="margin-top: 10px;">
            添加角色配置
          </el-button>
        </el-form-item>

        <!-- 进度指标 -->
        <el-form-item label="进度指标">
          <div v-for="(processItem, index) in newNode.process" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <span style="font-weight: bold; margin-right: 10px;">指标 {{index + 1}}</span>
              <el-button type="danger" size="mini" @click="removeProcess(newNode, index)">删除</el-button>
            </div>
            <el-form-item label="进度名称">
              <el-input v-model="processItem.name" placeholder="请输入进度名称，如'愤怒值'" />
            </el-form-item>
            <el-form-item label="进度提升规则">
              <el-input type="textarea" v-model="processItem.progress_change_rules" placeholder="请输入进度指标如何提升的规则" :autosize="{ minRows: 2, maxRows: 4 }" />
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开始进度值">
                  <el-input-number v-model="processItem.start_process" :min="0" placeholder="开始值" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束进度值">
                  <el-input-number v-model="processItem.end_process" :min="0" placeholder="结束值" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="奖励配置">
              <div v-for="(award, awardIndex) in processItem.award_conf" :key="awardIndex" style="border: 1px solid #eee; padding: 10px; margin-bottom: 8px; border-radius: 4px;">
                <div style="display: flex; align-items: center; margin-bottom: 8px;">
                  <span style="font-weight: normal; margin-right: 10px;">奖励 {{awardIndex + 1}}</span>
                  <el-button type="danger" size="mini" @click="removeProcessAward(processItem, awardIndex)">删除</el-button>
                </div>
                <el-form-item label="奖励类型">
                  <el-select v-model="award.type" placeholder="请选择奖励类型">
                    <el-option label="成就" value="成就" />
                    <el-option label="道具" value="道具" />
                    <el-option label="好感度" value="好感度" />
                    <el-option label="事件" value="事件" />
                    <el-option label="属性" value="属性" />
                  </el-select>
                </el-form-item>
                <el-form-item label="角色" v-if="award.type === '好感度'">
                  <el-select v-model="award.reward_character_id" placeholder="请选择角色">
                    <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="属性名称" v-if="award.type === '属性'">
                  <el-select v-model="award.attribute_name" placeholder="请选择属性">
                    <el-option label="武力值" value="武力值" />
                    <el-option label="智慧值" value="智慧值" />
                    <el-option label="体力值" value="体力值" />
                    <el-option label="灵敏值" value="灵敏值" />
                    <el-option label="精神值" value="精神值" />
                    <el-option label="圣母值" value="圣母值" />
                    <el-option label="黑化值" value="黑化值" />
                  </el-select>
                </el-form-item>
                <el-form-item label="奖励描述" v-if="award.type !== '好感度' && award.type !== '属性'">
                  <el-input
                    v-model="award.reward_description"
                    placeholder="请输入奖励描述"
                  />
                </el-form-item>
                <el-form-item label="好感度数值" v-if="award.type === '好感度'">
                  <el-input-number
                    :value="parseFloat(award.reward_description) || 0"
                    @input="award.reward_description = String($event)"
                    placeholder="请输入好感度数值"
                    :precision="0"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
                <el-form-item label="属性数值" v-if="award.type === '属性'">
                  <el-input-number
                    v-model="award.attribute_value"
                    placeholder="请输入属性数值"
                    :precision="0"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </div>
              <el-button type="primary" plain size="mini" @click="addProcessAward(processItem)" style="margin-top: 6px;">
                添加奖励
              </el-button>
            </el-form-item>
            <el-form-item label="后续剧情">
              <div v-if="Array.isArray(processItem.after_story) && processItem.after_story.length > 0">
                <draggable v-model="processItem.after_story" :handle="'.drag-after-story-handle'" animation="200">
                  <div
                    v-for="(story, storyIdx) in processItem.after_story"
                    :key="storyIdx"
                    style="border: 1px solid #eee; padding: 10px; margin-bottom: 8px; border-radius: 4px;"
                  >
                    <div style="display: flex; align-items: center; margin-bottom: 8px;">
                      <span class="drag-after-story-handle" style="cursor: move; font-size: 20px; margin-right: 6px;">⠿</span>
                      <span style="font-weight: normal; margin-right: 10px;">剧情对话 {{storyIdx + 1}}</span>
                      <el-button type="danger" size="mini" @click="removeAfterStoryItem(processItem, storyIdx)">删除</el-button>
                    </div>
                    <el-form-item label="角色">
                      <el-select v-model="story.role_id" placeholder="选择角色" style="width: 100%;">
                        <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="对话内容">
                      <el-input type="textarea" v-model="story.text" :autosize="{ minRows: 3, maxRows: 10 }" placeholder="请输入对话内容..." />
                    </el-form-item>
                  </div>
                </draggable>
              </div>
              <el-button type="primary" plain size="mini" @click="addAfterStoryItem(processItem)" style="margin-top: 6px;">
                添加后续剧情对话
              </el-button>
            </el-form-item>
          </div>
          <el-button type="primary" plain size="mini" @click="addProcess(newNode)" style="margin-top: 10px;">
            添加进度指标
          </el-button>
        </el-form-item>

        <!-- 彩蛋 -->
        <el-form-item label="彩蛋">
          <div v-for="(egg, index) in newNode.egg" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <span style="font-weight: bold; margin-right: 10px;">彩蛋 {{index + 1}}</span>
              <el-button type="danger" size="mini" @click="removeEgg(newNode, index)">删除</el-button>
            </div>
            <el-form-item label="彩蛋名称">
              <el-input v-model="egg.name" placeholder="请输入彩蛋名称" />
            </el-form-item>
            <el-form-item label="触发条件">
              <el-input type="textarea" v-model="egg.trigger_condition" placeholder="请输入触发条件" />
            </el-form-item>
            <el-form-item label="奖励类型">
              <el-select v-model="egg.reward_type" placeholder="请选择奖励类型">
                <el-option label="成就" value="成就" />
                <el-option label="道具" value="道具" />
                <el-option label="好感度" value="好感度" />
                <el-option label="事件" value="事件" />
                <el-option label="属性" value="属性" />
              </el-select>
            </el-form-item>
            <el-form-item label="角色" v-if="egg.reward_type === '好感度'">
              <el-select v-model="egg.reward_character_id" placeholder="请选择角色">
                <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="属性名称" v-if="egg.reward_type === '属性'">
              <el-select v-model="egg.attribute_name" placeholder="请选择属性">
                <el-option label="武力值" value="武力值" />
                <el-option label="智慧值" value="智慧值" />
                <el-option label="体力值" value="体力值" />
                <el-option label="灵敏值" value="灵敏值" />
                <el-option label="精神值" value="精神值" />
                <el-option label="圣母值" value="圣母值" />
                <el-option label="黑化值" value="黑化值" />
              </el-select>
            </el-form-item>
            <el-form-item label="具体奖励" v-if="egg.reward_type !== '好感度' && egg.reward_type !== '属性'">
              <el-input
                v-model="egg.reward_description"
                placeholder="请输入具体奖励描述"
              />
            </el-form-item>
            <el-form-item label="好感度数值" v-if="egg.reward_type === '好感度'">
              <el-input-number
                :value="parseFloat(egg.reward_description) || 0"
                @input="egg.reward_description = String($event)"
                placeholder="请输入好感度数值"
                :precision="0"
                controls-position="right"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="属性数值" v-if="egg.reward_type === '属性'">
              <el-input-number
                v-model="egg.attribute_value"
                placeholder="请输入属性数值"
                :precision="0"
                controls-position="right"
                style="width: 100%"
              />
            </el-form-item>
          </div>
          <el-button type="primary" plain size="mini" @click="addEgg(newNode)" style="margin-top: 10px;">
            添加彩蛋
          </el-button>
        </el-form-item>
        <!-- 输出示例 -->
        <el-form-item label="输出示例">
          <div v-for="(example, index) in newNode.output_examples" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <span style="font-weight: bold; margin-right: 10px;">示例 {{index + 1}}</span>
              <el-button type="danger" size="mini" @click="removeOutputExample(newNode, index)">删除</el-button>
            </div>
            <el-form-item label="示例内容">
              <el-input type="textarea" v-model="example.content" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入输出示例..." />
            </el-form-item>
          </div>
          <el-button type="primary" plain size="mini" @click="addOutputExample(newNode)" style="margin-top: 10px;">
            添加示例
          </el-button>
        </el-form-item>
        <!-- JSON输出示例 -->
        <el-form-item label="JSON输出示例">
          <div v-for="(example, index) in newNode.output_examples_json" :key="index" style="border: 1px solid #ddd; padding: 15px; margin-bottom: 10px; border-radius: 4px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <span style="font-weight: bold; margin-right: 10px;">JSON示例 {{index + 1}}</span>
              <el-button type="danger" size="mini" @click="removeOutputExampleJson(newNode, index)">删除</el-button>
            </div>
            <el-form-item label="示例内容">
              <el-input type="textarea" v-model="example.content" :autosize="{ minRows: 5, maxRows: 15 }" placeholder="请输入JSON输出示例..." />
            </el-form-item>
          </div>
          <el-button type="primary" plain size="mini" @click="addOutputExampleJson(newNode)" style="margin-top: 10px;">
            添加JSON示例
          </el-button>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="success" @click="createNodeData">添加</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import draggable from 'vuedraggable'
import {
  getNodes,
  getNode,
  updateNode,
  deleteNode,
  createNode,
  GameNode,
  changeNodeOrder,
  getChapters,
  Chapter,
  RoleConfig,
  PlayTarget,
  Egg,
  OutputExample,
  Reward,
  ProcessConfig, OutputExampleJson
} from '@/api/node'
import {getRoles, Role} from "@/api/role";
import {Game, getGames, getModels, saveGame, Model} from "@/api/game";
import {markRaw} from "vue";
import { getToken } from '@/utils/auth';

@Component({
  components: { draggable }
})
export default class NodeDetail extends Vue {
  @Prop({ required: true }) readonly game!: Game
  nodes: GameNode[] = []
  newNode: GameNode = {
    title: '',
    description: '',
    role_ids: [],
    prologue: '',
    node_type: "",
    dialogues: [],
    expanded: true,
    game_id: this.game?.id,
    bg_url: '',
    music_url: '',
    game_chapter_id: undefined,
    user_special: [],
    process: [],
    egg: [],
    story_background: '',
    current_plot: '',
    output_examples: [],
    output_examples_json: [],
    chapter_reward: [],
    limit_turn: undefined,
    node_task: ''
  }
  nodeTypeOptions = [
      { label: 'AI场景', value: 'ai' },
      { label: '固定剧情场景', value: 'fixed' }
    ]
  roles: Role[] = []
  chapters: Chapter[] = []

  uploadUrl = '/api_v2/upload'

  uploading = false

  get uploadHeaders() {
    const token = getToken()
    return token ? { Authorization: `Bearer ${token}` } : {}
  }
  models: Model[] = []

  @Watch("game", {immediate: true})
  onGameChange(newGame: Game){
    if (newGame && newGame.id) {
      this.loadData()
    }
  }

  mounted() {
    // this.loadData()
    // console.log(`game is ${this.game.title}`)
  }

  loadData() {
    let gameId = this.game.id
    getNodes(gameId)
      .then((res) => {
        let nodes: GameNode[] = []
        // console.log('API响应:', res)
        // console.log('第一个节点的output_examples_json:', res.data[0]?.output_examples_json)
        // console.log('第一个节点的output_examples_json类型:', typeof res.data[0]?.output_examples_json)
        // console.log('第一个节点的output_examples_json是否为数组:', Array.isArray(res.data[0]?.output_examples_json))
        
        if (!res.data || !Array.isArray(res.data)) {
          this.nodes = []
          return
        }

        for (let i of res.data){
          i.expanded = false
          // console.log(`节点${i.id}转换前的output_examples_json:`, i.output_examples_json)
          // console.log(`节点${i.id}转换前的output_examples:`, i.output_examples)
          // 转换后端数据格式为前端格式
          i = this.convertNodeDataFromBackend(i)
          // console.log(`节点${i.id}转换后的output_examples_json:`, i.output_examples_json)
          // console.log(`节点${i.id}转换后的output_examples:`, i.output_examples)
          // 确保 AI 节点的字段被正确初始化
          if (i.node_type === 'ai') {
            if (!i.user_special || !Array.isArray(i.user_special)) this.$set(i, 'user_special', [])
            if (!i.process || !Array.isArray(i.process)) this.$set(i, 'process', [])
            if (!i.egg || !Array.isArray(i.egg)) this.$set(i, 'egg', [])
            if (!i.story_background) this.$set(i, 'story_background', '')
            if (!i.current_plot) this.$set(i, 'current_plot', '')
            if (!i.output_examples || !Array.isArray(i.output_examples)) this.$set(i, 'output_examples', [])
            if (!i.output_examples_json || !Array.isArray(i.output_examples_json)) this.$set(i, 'output_examples_json', [])
            if (!i.chapter_reward || !Array.isArray(i.chapter_reward)) this.$set(i, 'chapter_reward', [])
          }
          nodes.push(i as GameNode)
        }
        this.nodes = nodes
        if (res.message) {
          this.$notify({
            title: '提示',
            message: res.message,
            type: 'warning',        // 或根据内容判断 success / error
            position: 'top-right',
            showClose: true,
            duration: 2000
          })
      }
      })
    getRoles(this.game.id).then((res)=>{
      this.roles = res
    })

    getChapters(this.game.id).then((res)=>{
      this.chapters = res.data
    })

    getModels().then((res)=>{
      this.models = res.data
    })
  }

  updateNodeData(node: GameNode) {
    if (!node.id) return
    // 创建数据副本并转换格式以兼容后端
    const nodeData = this.convertNodeDataForBackend(node)
    
    // 只发送数据库中存在的字段,移除前端特有的字段
    const cleanData: any = {}
    const allowedFields = [
      'game_id', 'game_chapter_id', 'title', 'description', 'order', 'has_task',
      'role_ids', 'version', 'prologue', 'epilogue', 'dialogues', 'node_type',
      'music_url', 'bg_url', 'bg_resource_id', 'music_resource_id',
      'prologue_role_id', 'epilogue_role_id', 'egg', 'process', 'user_special',
      'story_background', 'current_plot', 'output_examples', 'output_examples_json',
      'chapter_reward', 'start_process', 'end_process', 'node_task'
    ]
    
    allowedFields.forEach(field => {
      if (field in nodeData) {
        cleanData[field] = (nodeData as any)[field]
      }
    })
    
    console.log('发送到后端的清理后数据:', cleanData)
    
    updateNode(node.id, cleanData).then(async () => {
      this.$message.success('保存成功')
      // PUT 接口完成后，调用 GET 接口获取完整的节点信息（包含 chapter_list 的所有字段）
      try {
        const updatedNode = await getNode(node.id!)
        // 转换后端数据格式为前端格式
        const convertedNode = this.convertNodeDataFromBackend(updatedNode)
        // 保存后收起节点
        convertedNode.expanded = false
        // 确保 AI 节点的字段被正确初始化
        if (convertedNode.node_type === 'ai') {
          if (!convertedNode.user_special) this.$set(convertedNode, 'user_special', [])
          if (!convertedNode.process) this.$set(convertedNode, 'process', [])
          if (!convertedNode.egg) this.$set(convertedNode, 'egg', [])
          if (!convertedNode.story_background) this.$set(convertedNode, 'story_background', '')
          if (!convertedNode.current_plot) this.$set(convertedNode, 'current_plot', '')
          if (!convertedNode.output_examples) this.$set(convertedNode, 'output_examples', [])
          if (!convertedNode.output_examples_json) this.$set(convertedNode, 'output_examples_json', [])
          if (!convertedNode.chapter_reward) this.$set(convertedNode, 'chapter_reward', [])
        }
        // 找到并替换当前节点
        const index = this.nodes.findIndex(n => n.id === node.id)
        if (index !== -1) {
          this.$set(this.nodes, index, convertedNode)
        }
      } catch (error) {
        console.error('获取更新后的节点失败:', error)
        this.$message.error('获取更新后的节点失败')
      }
    }).catch((error) => {
      console.error('保存节点失败:', error)
      this.$message.error('保存失败: ' + (error.response?.data?.message || error.message))
    })
  }

  deleteNodeData(id?: number) {
    if (!id) return
    this.$confirm('确定删除该节点吗？', '提示', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteNode(id).then(() => {
        this.$message.success('删除成功')
        this.loadData()
      })
    })
  }

  onNewNodeTypeChange(val: string) {
    if (val === 'ai' && (!this.newNode.entry_conditions || this.newNode.entry_conditions.length === 0)) {
      this.newNode.entry_conditions = [{ type: '货币', value: 12, is_free: false }]
    }
  }

  createNodeData() {
    this.newNode.game_id = this.game.id
    // 创建数据副本并转换格式以兼容后端
    const nodeData = this.convertNodeDataForBackend(this.newNode)
    // 移除前端专用字段
    delete nodeData.expanded
    
    createNode(nodeData).then(() => {
      this.$message.success('新增成功')
      this.newNode = {
        title: '',
        description: '',
        role_ids: [],
        prologue: '',
        dialogues: [],
        node_type: "",
        expanded: true,
        game_id: this.game.id,
        bg_url: '',
        music_url: '',
        game_chapter_id: undefined,
        user_special: [],
        process: [],
        egg: [],
        story_background: '',
        current_plot: '',
        output_examples: [],
        output_examples_json: [],
        chapter_reward: [],
        limit_turn: undefined,
        node_task: ''
      }
      this.loadData()
    }).catch((error) => {
      console.error('创建节点失败:', error)
      this.$message.error('创建失败: ' + (error.response?.data?.message || error.message))
    })
  }
  onDragEnd() {
    let node_ids = this.nodes.map(n => n.id)
    console.log('新的顺序:', node_ids)
    // 你可以在这里调用后端 API 保存顺序
    changeNodeOrder(node_ids)
  }
  // addDialogue(node: GameNode) {
  //   if (this.roles.length != 0){
  //     node.dialogues.push({ role_id: this.roles[0].id, text: ''})
  //   }
  // }
  // removeDialogue(node: GameNode, didx: number) {
  //   node.dialogues.splice(didx, 1)
  // }
  // saveNode(node: GameNode) {
  //   // 这里提交 node 到后端
  //   // 例如 axios.post('/api/nodes', node) 或 axios.put...
  //   this.$message.success('保存成功')
  // }
  saveGame() {
    // 示例：可以将概要内容提交给后端
    saveGame(this.game.id, this.game);
    console.log('保存故事概要:', this.game)
    this.$message.success('故事概要已保存')
  }

  handleUploadSuccess(res: any, node: GameNode, field: 'bg_url' | 'music_url') {
    this.uploading = false
    if (res && res.url) {
      console.log(`url is : ${res.url}`)
      this.$set(node, field, res.url)
      if (field === 'bg_url' && res.id) {
        this.$set(node, 'bg_resource_id', res.id)
      } else if (field === 'music_url' && res.id) {
        this.$set(node, 'music_resource_id', res.id)
      }
    }
  }
  getFileName(url: string): string {
    if (!url) return ''
    try {
      const u = new URL(url, window.location.origin)
      const path = u.pathname
      const base = path.substring(path.lastIndexOf('/') + 1)
      return decodeURIComponent(base || '')
    } catch (e) {
      // 非绝对路径时用简单切分
      const parts = url.split('?')[0].split('#')[0].split('/')
      return decodeURIComponent(parts[parts.length - 1] || '')
    }
  }

  handleCoverUploadSuccess(res: any) {
    this.uploading = false
    if (res && res.url) {
      this.$set(this.game, 'url', res.url)
    }
  }

  addDialogue(node: GameNode) {
    if (this.roles.length != 0){
      if (node.dialogues == undefined){
        node.dialogues = []
      }
      node.dialogues.push({ role_id: this.roles[0].id, text: ''})
    }
  }
  removeDialogue(node: GameNode, didx: number) {
    node.dialogues.splice(didx, 1)
  }
  saveNode(node: GameNode) {
    // 这里提交 node 到后端
    // 例如 axios.post('/api/nodes', node) 或 axios.put...
    this.$message.success('保存成功')
  }

  playAudio(nodeId: number|undefined) {
    if (nodeId == undefined){
      return
    }
    const audioRefs = this.$refs.audioPlayerRef as HTMLAudioElement[] | HTMLAudioElement
    const audioList = Array.isArray(audioRefs) ? audioRefs : [audioRefs]

    for (let audioEl of audioList) {
      if (audioEl?.dataset?.id == String(nodeId)) {
        audioEl.play()
      } else {
        // 可选：暂停其他音频
        audioEl.pause?.()
      }
    }
  }

  addRoleConfig(node: GameNode) {
    if (!node.user_special) {
      this.$set(node, 'user_special', [])
    }
    (node.user_special as RoleConfig[]).push({
      role_id: this.roles.length > 0 ? this.roles[0].id : undefined,
      task: '',
      speak_timing: '',
      speak_tone: '',
      character_setting: ''
    })
  }

  removeRoleConfig(node: GameNode, index: number) {
    if (node.user_special) {
      node.user_special.splice(index, 1)
    }
  }

  addEgg(node: GameNode) {
    if (!node.egg) {
      this.$set(node, 'egg', [])
    }
    (node.egg as Egg[]).push({
      name: '',
      trigger_condition: '',
      reward_type: '',
      reward_description: '',
      reward_character_id: undefined
    })
  }

  removeEgg(node: GameNode, index: number) {
    if (node.egg) {
      node.egg.splice(index, 1)
    }
  }

  toggleNodeExpanded(node: GameNode) {
    node.expanded = !node.expanded
    // 当展开 AI 节点时，确保字段被初始化
    if (node.expanded && node.node_type === 'ai') {
      if (!node.user_special) this.$set(node, 'user_special', [])
      if (!node.process) this.$set(node, 'process', [])
      if (!node.egg) this.$set(node, 'egg', [])
      if (!node.story_background) this.$set(node, 'story_background', '')
      if (!node.current_plot) this.$set(node, 'current_plot', '')
      if (!node.output_examples) this.$set(node, 'output_examples', [])
      if (!node.output_examples_json) this.$set(node, 'output_examples_json', [])
      if (!node.chapter_reward) this.$set(node, 'chapter_reward', [])
    }
  }

  addOutputExample(node: GameNode) {
    if (!node.output_examples) {
      this.$set(node, 'output_examples', [])
    }
    const defaultContent = `###杀人魔
你现在做的事情非常危险，知道吗？
###旁白
杀人魔的手在微微发抖，他从未遇到过这样大胆的猎物。心脏不受控制地加速跳动，这种陌生的感觉让他既恼怒又困惑。
^^^40;0;0
&&&40;50;60
$$$80;50;60
@@@你是真的奔放;女淫贼
>>>`
    ;(node.output_examples as OutputExample[]).push({
      content: defaultContent
    })
  }

  removeOutputExample(node: GameNode, index: number) {
    if (node.output_examples) {
      node.output_examples.splice(index, 1)
    }
  }

  addOutputExampleJson(node: GameNode) {
    if (!node.output_examples_json) {
      this.$set(node, 'output_examples_json', [])
    }
    const defaultContent = `{
  "point": {
    "进度值": 0
  },
  "is_end": true,
  "dialogues": [
    {
      "role": "旁白",
      "content": "你颤抖着推开写着\\"工作\\"的门，小心翼翼地确认里面没有怪物后，迅速闪身进去并将门反锁。"
    }
  ],
  "easter_eggs": "",
  "progress_change": {
    "进度值": 100
  },
  "accumulated_progress": {
    "进度值": 100
  }
}`
    ;(node.output_examples_json as OutputExampleJson[]).push({
      content: defaultContent
    })
  }

  removeOutputExampleJson(node: GameNode, index: number) {
    if (node.output_examples_json) {
      node.output_examples_json.splice(index, 1)
    }
  }

  addChapterReward(node: GameNode) {
    if (!node.chapter_reward) {
      this.$set(node, 'chapter_reward', [])
    }
    (node.chapter_reward as Reward[]).push({
      type: '',
      reward_description: ''
    })
  }

  removeChapterReward(node: GameNode, index: number) {
    if (node.chapter_reward) {
      node.chapter_reward.splice(index, 1)
    }
  }

  addProcess(node: GameNode) {
    if (!node.process) {
      this.$set(node, 'process', [])
    }
    const defaultRules = `- 暧昧值不直接显示出来，只做隐藏记录
- 暧昧值增长规则：用户说出 "挑逗杀人魔" 的话术，暧昧值增加 40 点（如 0→40→80→120）。此时杀人魔语言表现出很抗拒但是内心却有点喜欢这种行为（需要通过旁白描述杀人魔内心真实的想法）
- 暧昧值增加时，旁白需描述杀人魔此时内心最真实的想法
- 暧昧值不增加规则：用户说的内容不是挑逗杀人魔的话术，则暧昧值不变
- 暧昧值达到100时：杀人魔突然怒斥打断用户这种调戏行为(如：够了，你个疯女人)`
    ;(node.process as ProcessConfig[]).push({
      name: '',
      start_process: 0,
      end_process: 100,
      progress_change_rules: defaultRules,
      award_conf: [],
      after_story: undefined
    })
  }

  removeProcess(node: GameNode, index: number) {
    if (node.process) {
      node.process.splice(index, 1)
    }
  }

  addProcessAward(processItem: ProcessConfig) {
    if (!processItem.award_conf) {
      processItem.award_conf = []
    }
    processItem.award_conf.push({
      type: '',
      reward_description: ''
    })
  }

  removeProcessAward(processItem: ProcessConfig, index: number) {
    if (processItem.award_conf) {
      processItem.award_conf.splice(index, 1)
    }
  }

  addAfterStoryItem(processItem: ProcessConfig) {
    if (!processItem.after_story || !Array.isArray(processItem.after_story)) {
      this.$set(processItem, 'after_story', [])
    }
    (processItem.after_story as any[]).push({
      role_id: this.roles.length > 0 ? this.roles[0].id : undefined,
      text: ''
    })
  }

  removeAfterStoryItem(processItem: ProcessConfig, index: number) {
    if (Array.isArray(processItem.after_story)) {
      processItem.after_story.splice(index, 1)
    }
  }

  // 将前端数据格式转换为后端兼容格式
  convertNodeDataForBackend(node: GameNode): GameNode {
    const nodeData = JSON.parse(JSON.stringify(node)) // 深拷贝

    console.log('转换前的 chapter_reward:', nodeData.chapter_reward)
    console.log('转换前的 process:', nodeData.process)

    // 确保 chapter_reward 是数组格式
    if (!Array.isArray(nodeData.chapter_reward)) {
      if (nodeData.chapter_reward) {
        // 如果是单个对象，转换为数组
        nodeData.chapter_reward = [nodeData.chapter_reward]
      } else {
        // 如果是 null 或 undefined，设置为空数组
        nodeData.chapter_reward = []
      }
    }

    // 确保 process 是数组格式
    if (!Array.isArray(nodeData.process)) {
      if (nodeData.process) {
        // 如果是单个对象，转换为数组
        nodeData.process = [nodeData.process]
      } else {
        // 如果是 null 或 undefined，设置为空数组
        nodeData.process = []
      }
    }

    // 过滤掉无效的奖励项并确保好感度类型有角色ID
    nodeData.chapter_reward = nodeData.chapter_reward.filter((r: Reward) => {
      // 基本验证：必须有奖励类型
      if (!r || !r.type || r.type.trim() === '') {
        return false
      }

      // 如果是好感度类型，必须有角色ID
      if (r.type === '好感度' && !r.reward_character_id) {
        console.warn('好感度奖励缺少角色ID，已过滤掉:', r)
        return false
      }

      return true
    })

    console.log('转换后的 chapter_reward:', nodeData.chapter_reward)
    console.log('转换后的 process:', nodeData.process)
    
    // 处理 output_examples_json: 将 {content: "JSON字符串"} 转回 JSON对象
    if (Array.isArray(nodeData.output_examples_json)) {
      console.log('开始转换 output_examples_json, 原始数据:', nodeData.output_examples_json)
      nodeData.output_examples_json = nodeData.output_examples_json.map((example: any, index: number) => {
        console.log(`处理第 ${index + 1} 个示例:`, example)
        // 如果有 content 字段,说明这是前端编辑格式,需要解析
        if (example && typeof example === 'object' && 'content' in example) {
          console.log(`  - 有 content 字段, 内容类型: ${typeof example.content}`)
          if (typeof example.content === 'string') {
            try {
              // 尝试解析 content 字段中的 JSON 字符串
              const parsed = JSON.parse(example.content)
              console.log(`  - 解析成功:`, parsed)
              return parsed
            } catch (e) {
              console.error(`  - 解析失败! 错误:`, e, '原始内容:', example.content)
              return example // 如果解析失败,保留原样
            }
          }
        }
        // 如果没有 content 字段,说明已经是正确的 JSON 对象格式,直接返回
        console.log(`  - 没有 content 字段或不是对象,保持原样`)
        return example
      })
      console.log('转换后的 output_examples_json:', nodeData.output_examples_json)
    }
    
    console.log('最终发送的数据:', nodeData)
    return nodeData
  }

  // 将后端数据格式转换为前端格式
  convertNodeDataFromBackend(node: GameNode): GameNode {
    // 确保 chapter_reward 始终是数组
    if (!node.chapter_reward) {
      node.chapter_reward = []
    } else if (!Array.isArray(node.chapter_reward)) {
      // 如果后端返回的是单个对象，转换为数组
      node.chapter_reward = [node.chapter_reward] as Reward[]
    }

    // 确保 process 始终是数组
    if (!node.process) {
      node.process = []
    } else if (!Array.isArray(node.process)) {
      // 如果后端返回的是单个对象，转换为数组
      node.process = [node.process] as ProcessConfig[]
    }
    
    // 确保 process 中的 after_story 是数组格式
    if (Array.isArray(node.process)) {
      node.process.forEach((processItem: any) => {
        if (processItem.after_story) {
          if (!Array.isArray(processItem.after_story)) {
            // 如果是字符串，尝试解析为 JSON
            if (typeof processItem.after_story === 'string') {
              try {
                processItem.after_story = JSON.parse(processItem.after_story)
              } catch (e) {
                console.warn('无法解析 after_story 字符串:', processItem.after_story)
                processItem.after_story = []
              }
            } else {
              // 如果是单个对象，转换为数组
              processItem.after_story = [processItem.after_story]
            }
          }
        } else {
          processItem.after_story = []
        }
      })
    }

    // 确保 dialogues 始终是数组
    if (!node.dialogues) {
      node.dialogues = []
    }

    // 确保 role_ids 始终是数组
    if (!node.role_ids) {
      node.role_ids = []
    }

    // 确保 user_special 始终是数组（AI节点）
    if (!node.user_special) {
      node.user_special = []
    }

    // 确保 egg 始终是数组（AI节点）
    if (!node.egg) {
      node.egg = []
    }

    // 确保 output_examples 始终是数组（AI节点）
    if (!node.output_examples) {
      node.output_examples = []
    } else if (!Array.isArray(node.output_examples)) {
      // 如果后端返回的是单个对象，转换为数组
      node.output_examples = [node.output_examples] as OutputExample[]
    }

    // 确保 output_examples_json 始终是数组（AI节点）
    if (!node.output_examples_json) {
      node.output_examples_json = []
    } else if (!Array.isArray(node.output_examples_json)) {
      // 如果后端返回的是单个对象，转换为数组
      node.output_examples_json = [node.output_examples_json] as OutputExampleJson[]
    } else {
      // 如果数组中的对象没有content字段,将整个对象序列化为content
      node.output_examples_json = node.output_examples_json.map((example: any) => {
        // console.log('处理 output_examples_json 项:', example, '类型:', typeof example, '有content?:', 'content' in example)
        if (typeof example === 'object' && example !== null && !('content' in example)) {
          const wrapped = { content: JSON.stringify(example, null, 2) }
          // console.log('包装后:', wrapped)
          return wrapped
        }
        console.log('保持原样')
        return example
      })
    }

    // 确保字符串字段不为 null
    if (node.story_background === null || node.story_background === undefined) {
      node.story_background = ''
    }
    if (node.current_plot === null || node.current_plot === undefined) {
      node.current_plot = ''
    }
    if (node.node_task === null || node.node_task === undefined) {
      node.node_task = ''
    }
    if (node.prologue === null || node.prologue === undefined) {
      node.prologue = ''
    }
    if (node.bg_url === null || node.bg_url === undefined) {
      node.bg_url = ''
    }
    if (node.music_url === null || node.music_url === undefined) {
      node.music_url = ''
    }

    return node
  }

  // 复制节点
  copyNode(node: GameNode) {
    // 深拷贝节点数据，排除id
    const copiedNodeData: GameNode = {
      ...JSON.parse(JSON.stringify(node)),
      id: undefined,
      game_id: this.game.id,
      title: node.title + ' (副本)'
    }

    // 转换为后端格式
    const nodeData = this.convertNodeDataForBackend(copiedNodeData)
    // 移除前端专用字段
    delete nodeData.expanded

    // 调用创建接口
    createNode(nodeData).then(() => {
      this.$message.success('复制成功')
      this.loadData()
    }).catch((error) => {
      console.error('复制节点失败:', error)
      this.$message.error('复制失败: ' + (error.response?.data?.message || error.message))
    })
  }
}
</script>

<style scoped>
.node-wrapper {
  padding: 20px;
}
.node-block {
  background: #f9f9f9;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 8px;
}
.upload-bg, .upload-music {
  margin-bottom: 10px;
}
</style>
<style scoped>
.drag-dialogue-handle {
  user-select: none;
}
</style>